export const sortByValueFunction = (v1: number, v2: number) => {
  return v1 === v2 ? 0 : v1 > v2 ? 1 : -1
}
